import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-searchable-dropdown',
  templateUrl: './searchable-dropdown.component.html',
  styleUrls: ['./searchable-dropdown.component.css']
})
export class SearchableDropdownComponent implements OnInit {
  loading=false
  @Input() itemList:any[]
  @Input() defaultText:string
  @Input() defaultValue:string
  @Input() isDisabled:boolean=false
  @Input() isLastPage:boolean=false
  @Input() isPastorDropdown:boolean=false
  @Output() onItemSelect= new EventEmitter<string>()
  @Output() onSearchTermChange= new EventEmitter<string>()
  @Output() onListPageChange = new EventEmitter<boolean>()
  @Input() theme:string
  selectedItem:any
  searchterm:string
  showDropdown:boolean=false
  constructor() { }

  ngOnInit(): void {
  }

  // get list(){
  //   return this.itemList;
  // }

  ngOnChanges(changes: SimpleChanges) {

    if(changes.itemList?.previousValue !== changes.itemList?.currentValue){
      this.selectedItem=null
      // console.log(changes.itemList.previousValue)
      // console.log(changes.itemList.currentValue)
    }
    
    //

}

  toggleDropdown(){
    this.showDropdown=!this.showDropdown
  }

  selectItem(item){
    this.selectedItem=item
    this.onItemSelect.emit(item)
    this.toggleDropdown()
  }

  onsearchChange(event:any){
    this.onSearchTermChange.emit(event?.target.value)
  }

  onScroll(event: any) {
    // console.log("here" )
    // console.log("here",event.target )
    // console.log(event.target.offsetHeight , event.target.scrollTop , event.target.scrollHeight , !this.isLastPage ,event.target.offsetHeight + event.target.scrollTop )
    // console.log(event.target.offsetHeight , event.target.scrollTop , event.target.scrollHeight , !this.isLastPage )
    // visible height + pixel scrolled >= total height 
    if (event.target.offsetHeight + event.target.scrollTop + 1 >= event.target.scrollHeight && !this.isLastPage) {

      if(!this.loading){
      this.loading=true
      this.onListPageChange.emit(true)
      }
    }
  }

  fetchMore() {
    if (!this.isLastPage) {
      this.loading=true
      this.onListPageChange.emit(true)
    }
  }



}
